import { Registrant } from '../types/Registrant';

// How Neighbors shows a resident (Matt confirmed): their own Neighbors choice first, else the official record.
// Name, per field: SocialProfile.FirstName / LastName, else FirstName / LastName.
// Photo: SocialProfile.Image, else the community system photo (PCC, AugustHealth etc.), else the staff upload.
// live-be applies the same rule to everything it returns to Neighbors (utils/residentIdentity.js), so the
// logged-in resident looks the same here as in the feed, comments and directory.
// Display only: staff-facing payloads (check-in, calendar attendees) keep sending the official record.

type ResidentLike = Pick<Registrant, 'FirstName' | 'LastName' | 'Image' | 'ExternalResidentImage' | 'SocialProfile'>;

const clean = (value?: string) => (typeof value === 'string' ? value.trim() : '');

export const getResidentDisplayFirstName = (resident?: ResidentLike | null): string =>
    clean(resident?.SocialProfile?.FirstName) || clean(resident?.FirstName);

export const getResidentDisplayLastName = (resident?: ResidentLike | null): string =>
    clean(resident?.SocialProfile?.LastName) || clean(resident?.LastName);

export const getResidentDisplayFullName = (resident?: ResidentLike | null): string =>
    [getResidentDisplayFirstName(resident), getResidentDisplayLastName(resident)].filter(Boolean).join(' ');

// Every usable photo in display order, without repeats, so an avatar can move to the next one if a link fails to load.
export const getResidentDisplayImages = (resident?: ResidentLike | null): string[] => {
    const images = [resident?.SocialProfile?.Image, resident?.ExternalResidentImage, resident?.Image].map(clean).filter(Boolean);
    return images.filter((image, index) => images.indexOf(image) === index);
};

export const getResidentDisplayImage = (resident?: ResidentLike | null): string =>
    getResidentDisplayImages(resident)[0] || '';
